import React from 'react';
import { TextField } from '@mui/material';

interface DateFieldsProps {
    effectiveDate: string;
    endDate: string;
    effectiveDateError?: string;
    endDateError?: string;
    onEffectiveDateChange: (value: string) => void;
    onEndDateChange: (value: string) => void;
}

export const DateFields: React.FC<DateFieldsProps> = ({
    effectiveDate,
    endDate,
    effectiveDateError,
    endDateError,
    onEffectiveDateChange,
    onEndDateChange
}) => {
    return (
        <>
            <TextField
                label="Effective Date"
                type="date"
                value={effectiveDate}
                onChange={(e) => onEffectiveDateChange(e.target.value)}
                error={!!effectiveDateError}
                helperText={effectiveDateError || 'Optional start date for this fee schedule'}
                size="small"
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
            />

            <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => onEndDateChange(e.target.value)}
                error={!!endDateError}
                helperText={endDateError || 'Optional end date for this fee schedule'}
                size="small"
                fullWidth
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </>
    );
};
